export const developer = {
  developers: '开发人员',
  enpowerYourDevelopersToHarnessTheFullPotential: '赋予您的开发人员充分利用仪表板的潜力',
  accessToken: '访问令牌',
  yourAPI: '您的API',
  api: {
    apiManagement: 'API管理',
    apiManagementSubHeading: '添加、配置、测试和管理您的API，您可以在聊天流程中触发使用。',
    addApi: '添加API',
    createApi: '创建API',
    noApiFound: '未找到API！',
    deleteApis: '删除API',
    areYouSureYouWantToDeleteAPI: '您确定要删除API吗',
    placeholders: {
      search: '按API名称搜索'
    },
    tableHead: {
      method: '方法',
      apiName: 'API名称',
      url: 'URL',
      actions: '操作'
    },
    parametersTab: '参数',
    headersTab: '标头',
    bodyTab: '主体标签',
    manageApiResponses: '管理API响应',
    chooseVariableToSave: '选择要保存的变量',
    selectCustomAttribute: '选择自定义属性',
    subTab: {
      key: '键',
      enterKey: '输入键',
      value: '值',
      enterValue: '输入值',
      addAnotherField: '添加另一个字段',
      save: '保存',
      useslashToInsertCustomVariables: '使用‘/’插入用户响应中的自定义变量或动态值。',
      response: '响应',
      apiRequestBody: 'API请求主体',
      hit: '点击',
      test: '测试',
      buttonToGetAResponse: '按钮获取响应',
      variable: '变量',
      saveToCustomAttribute: '保存到自定义属性',
      encryptedKey: '密钥（已加密）',
      noOptionsAvailable: '没有可用的选项',
      addAuthenticationField: '添加身份验证字段'
    },
    apiLogs: {
      apiManagement: 'API管理',
      addConfigureTestAndManageYourAPIs: '添加、配置、测试和管理您的API，您可以在聊天流程中触发使用。',
      searchHere: '按状态代码搜索',
      deleteApis: '删除API',
      testAnApi: '测试API',
      noAPILogFound: '未找到API日志',
      responseCode: '响应代码',
      message: '消息',
      apiResponse: 'API响应',
      actions: '操作',
      deleteAPIs: '删除API日志',
      areYouSureYouWantToDelete: '您确定要删除此API日志吗？',
      apiLogs: 'API日志',
      subTitle: '聊天机器人聊天流程中触发的所有API请求和响应的详细记录。'
    }
  },
  configApi: {
    configureApi: '配置API',
    configureApiSubHeading: '您可以在此处配置基于JSON的API并在丰富聊天流程中使用。',
    apiLogs: 'API日志',
    test: '测试',
    manageApiResponse: '管理API响应',
    body: '主体',
    headers: '标头',
    parameters: '参数',
    testyourRequest: '测试您的请求',
    testRequestDescription: '您的请求包含变量，您可以手动设置其值以进行测试。',
    apiName: 'API名称',
    placeholders: {
      enterApiName: '输入API名称',
      enterApiUrl: '输入API URL',
      enterTestValue: '输入测试值'
    }
  }
};
